import { render, staticRenderFns } from "./ChamberEdit.vue?vue&type=template&id=548ef3fa&scoped=true&"
import script from "./ChamberEdit.vue?vue&type=script&lang=js&"
export * from "./ChamberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ef3fa",
  null
  
)

export default component.exports